import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import LangContext from 'client/utils/lang-context';

interface Props {
    title: string;
    sectionTitle?: string | undefined;
    dontUseSuffix?: boolean;
}

export default class Seo extends Component<Props> {
    static contextType = LangContext;

    render() {
        const {
            title,
            sectionTitle,
            dontUseSuffix
        } = this.props;

        const { dictionary, lang } = this.context;

        const titleParts = [dictionary.sitename, dictionary.mainname];

        if (!dontUseSuffix) {
            if (sectionTitle && lang === 'en') {
                titleParts.unshift(sectionTitle);
            }

            titleParts.unshift(title);
        }

        const preparedTitle = titleParts.join(' | ');

        return (
            <Helmet>
                <title>{preparedTitle}</title>

                <meta name="title" content={preparedTitle} />
                <meta name="og:title" content={preparedTitle} />
                <meta name="twitter:title" content={preparedTitle} />
            </Helmet>
        );
    }
}
